var React = require('react');

function GripLinesVertical (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224,16V496a16,16,0,0,1-16,16H176a16,16,0,0,1-16-16V16A16,16,0,0,1,176,0h32A16,16,0,0,1,224,16Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M96,16V496a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V16A16,16,0,0,1,48,0H80A16,16,0,0,1,96,16Z","className":"fa-primary","key":2})]);
}

GripLinesVertical.defaultProps = {"viewBox":"0 0 256 512","className":"icon"};

module.exports = GripLinesVertical;

GripLinesVertical.default = GripLinesVertical;
